var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"swiper",staticClass:"swiper",style:(_vm.createStyle(Object.assign({}, _vm.webStyle,
    {flex: 1,
    display: 'block',
    position: 'relative',
    boxSizing: 'border-box',
    overflowX: 'hidden'}))),on:{"touchstart":_vm.touchstart,"touchmove":_vm.touchmove,"touchend":_vm.touchend}},[_c('div',{class:{'swiper-animation': _vm.needAnimation && _vm.hasAnimation},style:(_vm.createStyle({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      width: 100 * _vm.slideSlideLength + '%',
      flex: 0,
      position: 'relative',
      transform: _vm.transformValue,
      height: '100%',
    }))},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }